import { AnyAction } from 'redux';
import cloneDeep from 'lodash/cloneDeep';
import {
  GlobalActions,
  ProduktDeleted,
  RbdChanged,
  VereinbarungenChanged,
} from '@ps20-frontend/shop-integration-redux';
import { RBD } from '../interfaces/rbd';
import { ToolbarActions } from '../toolbar.actions';

export const rbdReducer = function (
  sectionState: Array<RBD> = null,
  action: AnyAction,
): Array<RBD> {
  switch (action.type) {
    case ToolbarActions.RBD_MAX_UPDATED: {
      return action.payload;
    }
    case ToolbarActions.RBD_CHANGED_TEMP: {
      const actionPayload: RbdChanged = action.payload;
      if (actionPayload.rbd != null && actionPayload.appId != null) {
        return sectionState.map(elem => {
          if (elem.appId === actionPayload.appId && elem.angebotsId === actionPayload.angebotsId) {
            return {
              ...elem,
              rbd_changed: actionPayload.rbd,
            };
          }
          return elem;
        });
      } else {
        return sectionState.map(elem => {
          return { ...elem, rbd_changed: elem.rbd_aktuell };
        });
      }
    }
    case GlobalActions.VEREINBARUNGEN_CHANGED: {
      let newState: Array<RBD> = cloneDeep(sectionState);
      const actionPayload: VereinbarungenChanged = action.payload;
      newState = newState.map(rbd => {
        const actionPayloadRBD = actionPayload.rbdChanges.find(
          payloadRbd => payloadRbd.appId === rbd.appId && payloadRbd.angebotsId === rbd.angebotsId,
        );
        if (actionPayloadRBD) {
          rbd.rbd_aktuell = actionPayloadRBD.rbd;
        }
        return rbd;
      });
      return newState;
    }
    case GlobalActions.PRODUKT_DELETED: {
      let newState: Array<RBD> = cloneDeep(sectionState);
      const actionPayload: ProduktDeleted = action.payload;
      newState = newState.filter(elem => {
        return !actionPayload.angebotsIds.some(
          angebotsId =>
            angebotsId.appId === elem.appId && angebotsId.angebotsId === elem.angebotsId,
        );
      });
      return newState;
    }
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA: {
      if (action.payload) {
        return sectionState.map(rbd => ({ ...rbd, rbd_aktuell: 0 }));
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
